import _ from 'lodash'

/**
 * @type {MyHomeVuexState}
 */
const initialState = {

    /**
     * @type {Array<MyHomeStateEdit>}
     */
    edits: [],

    /**
     * @type {Array<string>}
     */
    errors: [],

    loaded: false,

    /**
     * @returns {?PsmaAttributionInfo}
     */
    psmaAttributionInfo: null,

    segments: [],

    summaryBullets: [],

    /**
     * @type {string}
     */
    summaryText: '',

    /**
     * @type {Array<string>}
     */
    warnings: [],
}

const state = _.cloneDeep(initialState)

/**
 * @type {MyHomeVuexState}
 */
export { initialState }

export default state
